import React from 'react'
import { Card, Button } from 'react-bootstrap'
import Rating from './Rating'
import { Link, useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { addToCart } from '../actions/cartActions'

function Product({ product }) {
    const history = useHistory()
    const dispatch = useDispatch()

    const addToCartHandler = () => {
        dispatch(addToCart(product._id, 1)) // Add 1 quantity by default
        history.push('/cart')
    }

    return (
        <Card className="my-3 p-3 rounded border-0 shadow-sm product-card">
            <Link to={`/product/${product._id}`}>
                <Card.Img src={product.image} />
            </Link>

            <Card.Body>
                <Link to={`/product/${product._id}`}>
                    <Card.Title as="div">
                        <strong>{product.name}</strong>
                    </Card.Title>
                </Link>

                <Card.Text as="div">
                    <div className="my-3">
                        <Rating value={product.rating} text={`${product.numReviews} reviews`} color={'#f8e825'} />
                    </div>
                </Card.Text>


                <Card.Text as="h3">
                    €{product.price}
                </Card.Text>
                <Button
                    onClick={addToCartHandler}
                    variant="primary"
                    className="w-100"
                    disabled={product.countInStock === 0}
                >
                    Add to Cart
                </Button>
            </Card.Body>
        </Card>
    )
}

export default Product
